module.exports = __webpack_public_path__ + "img/icon_attribute_pure_64.ee8c0a42.png";